import type React from 'react';

import type { IconProps } from 'types/icon';

const XClose: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M19.1465 4.14645C19.3418 3.95118 19.6583 3.95118 19.8535 4.14645C20.0488 4.34171 20.0488 4.65822 19.8535 4.85348L12.7071 12L19.8535 19.1464C20.0488 19.3417 20.0488 19.6582 19.8535 19.8535C19.6583 20.0487 19.3418 20.0487 19.1465 19.8535L12 12.707L4.85354 19.8535C4.65828 20.0487 4.34177 20.0487 4.14651 19.8535C3.95125 19.6582 3.95125 19.3417 4.14651 19.1464L11.293 12L4.14651 4.85348C3.95125 4.65822 3.95125 4.34171 4.14651 4.14645C4.34177 3.95118 4.65828 3.95118 4.85354 4.14645L12 11.2929L19.1465 4.14645Z"
        fill={color}
      />
    </svg>
  );
};

export default XClose;
